/**
 * This component renders the standings tab for a club page
 * WARNING - Currently using dummy data
 */
import React from "react";
import Standings from "../core/Standings";

const ClubStandings = ({ clubData }) => {
  // const gradientStyle = {
  //   background: `linear-gradient(to right, ${clubData.primary_color}, ${clubData.secondary_color})`,
  // };

  return (
    // Container for all pages
    <Standings 
      type="club" 
      clubID={clubData.id}
      divisionID={null}
      seasons={clubData.divisions_seasons}
    />
  );
}

export default ClubStandings;